/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Loading from '~/components/loading';
import Container from '~/components/container';

import ListConference from '../components/listConference';
import HeaderConference from '../components/headerConference';

import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';

import * as St from './styles';
import { IAntecipationPurchase } from '../model';
import { currencyMask } from '~/utils/masks';
import { icons } from '~/assets';

const AntecipationConferenceLoan: React.FC = () => {
  const history = useHistory<any>();
  const locationState = history.location.state;

  const [valorTotal, setValorTotal] = useState('');
  const [descontoTotal, setDescontoTotal] = useState('');
  const [dialog, setDialog] = useState({ open: false, error: false });
  const [dialogMessage, setDialogMessage] = useState('');
  const [data, setData] = useState<IAntecipationPurchase[]>(null);

  const RequestCreateAntecipation = useApi(
    Endpoints.invoices.postAntecipationArray,
    ApiMethod.POST,
  );

  useEffect(() => {
    const value = [] as IAntecipationPurchase[];
    locationState?.dataPurchase?.map((dataP: IAntecipationPurchase) => {
      if (dataP.parcelasAAntecipar > 0) {
        value.push(dataP);
      }
      return dataP;
    });
    setData(value);
  }, []);

  useEffect(() => {
    async function populaValor() {
      let aux = 0;
      let auxDesconto = 0;
      if (data) {
        setValorTotal('');
        setDescontoTotal('');
        data.map((item) => {
          aux = item.valorAntecipacao + aux;
        });
        data.map((item) => {
          auxDesconto = item.valorDesconto + auxDesconto;
        })
        setValorTotal(String(aux));
        setDescontoTotal(String(auxDesconto));
      }
    }

    populaValor();
  }, [data]);

  const requestFinancialParcel = async () => {
    const payload = [] as any[];
    data.map((dataP: IAntecipationPurchase) => {
      payload.push({
        cartao: dataP?.cartao,
        cpf: dataP?.cpf,
        dataFechamento: String(moment(dataP?.dataCorte).format('YYYY-MM-DD')),
        email: dataP?.email,
        idParcelamento: dataP.idEmprestimo,
        nomeCliente: dataP?.nomeCompleto,
        parcelasAntecipadas: dataP?.parcelasAAntecipar,
        valorAntecipacao: dataP?.valorReal,
        tipoAntecipacao: 'SAQUE',
      });
    });

    try {
      const response: any = await RequestCreateAntecipation.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        setDialog({ open: true, error: false });
        setDialogMessage('Solicitação enviada com sucesso!');
      } else {
        setDialog({ open: true, error: true });
        setDialogMessage(
          response.data?.mensagem || 'Tivemos um erro, Tente novamente!',
        );
      }
    } catch (err) {
      setDialog({ open: true, error: true });
      setDialogMessage('Tivemos um erro, Tente novamente!');
    }
  };

  function handleClick() {
    history.push('/invoice/antecipation-loan/payment', {
      locationState,
    });
  }

  return (
    <Container>
      <Loading status={RequestCreateAntecipation.loading} />
      <Dialog
        icon={dialog?.error ? icons.exclamation : icons.check}
        open={dialog?.open}
        positiveLabel="Entendi"
        positiveAction={() => {
          if (!dialog.error) {
            history.push('/invoice/antecipation/purchase');
          }
          setDialog({ open: false, error: false });
        }}
        message={dialogMessage}
      />
      {data?.length > 0 ? (
        <>
          <HeaderConference
            nomeCompleto={data[0]?.nomeCompleto}
            cpf={data[0]?.cpf}
            numeroCartao={data[0]?.cartao}
            valorTotal={Number(valorTotal)}
            data={locationState?.dataPurchase}
            descontoTotal={Number(descontoTotal)}
          />

          <St.BoxCard>
            <ListConference data={data} />

            <ContainerFlex marginBottom={20}>
              <ContainerFlex row marginLeft={20}>
                <St.IconExclamation
                  src={icons.exclamation}
                  alt="Logo TeuCard"
                />
                <St.DescriptionInfo>ANTECIPAÇÃO DE EMPRÉSTIMO</St.DescriptionInfo>
              </ContainerFlex>
              <ContainerFlex marginLeft={18}>
                <St.DescriptionInfo>
                  {`Comunique o cliente para realizar o pagamento em até 24h. Caso não seja realizado o pagamento, a solicitação é automaticamente cancelada.
                   O valor total a pagar é R$ ${currencyMask(
                      Number(valorTotal)
                    )}. Confirma a antecipação? `}
                </St.DescriptionInfo>
              </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex row end padding={15}>
              <Button fitContent onClick={handleClick}>
                <span>Escolher Pagamento</span>
              </Button>
            </ContainerFlex>
          </St.BoxCard>
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default AntecipationConferenceLoan;
